import {
  NgModule
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';
import {
  NgbModule
} from '@ng-bootstrap/ng-bootstrap';
import {
  ToggleFullScreenDirective
} from './fullscreen/toggle-fullscreen.directive';
import {
  AccordionAnchorDirective
} from './accordion/accordionanchor.directive';
import {
  AccordionLinkDirective
} from './accordion/accordionlink.directive';
import {
  AccordionDirective
} from './accordion/accordion.directive';
import {
  AngularGooglePlaceModule
} from '../../lib/angular-google-place/index';
import {
  HttpClientModule,
  HttpClient
} from '@angular/common/http';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {
  TranslateModule,
  TranslateLoader
} from '@ngx-translate/core';
import {
  TranslateHttpLoader
} from '@ngx-translate/http-loader';
import {
  AngularMultiSelectModule
} from 'angular2-multiselect-dropdown';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import {
  TitleComponent
} from '../layout/admin/title/title.component';
import {
  CardComponent
} from './card/card.component';
import {
  CardToggleDirective
} from './card/card-toggle.directive';
import {
  ModalBasicComponent
} from './modal-basic/modal-basic.component';
import {
  ModalAnimationComponent
} from './modal-animation/modal-animation.component';
import {
  FieldErrorDisplayComponent
} from '../component/field-error-display/field-error-display.component';
import {
  SpinnerComponent
} from './spinner/spinner.component';
import {
  ClickOutsideModule
} from 'ng-click-outside';
import {
  ShowErrorsComponent
} from './reusable-components/error-display.component';
import {
  GroupByPipe
} from './customPipe/group';
import {
  PhonePipe
} from './customPipe/PhonePipe';
import {
  SanitizeHtmlPipe
} from './customPipe/safe.pipe';
import {
  NaPipe
} from './customPipe/NA';
import {
  OriginalFileName
} from './customPipe/orginalFileName';
import {
  OriginalFileShortName
} from './customPipe/originalShortFileName';
import {
  CustomStatusPipe
} from './customPipe/customStatus';
import {
  MiniBuyerProfileComponent
} from '../component/buyer/component/mini-buyer-profile/mini-buyer-profile.component';
import {
  DotLimit
} from './customPipe/dotLimit';
import {
  NPSColorStates
} from './customPipe/npsColorStates';
import {
  dateFormatPipe
} from './customPipe/dateFormat';
import {
  DialogModule
} from 'primeng/dialog';
import {
  SanitizeNolImtHtmlPipe
} from './customPipe/safenolimit';
import {
  RfqCapabilitiesComponent
} from '../component/rfq/rfq-detail/components/rfq-capabilities/rfq-capabilities.component';
import { QuoteSupplierProfileComponent } from '../component/rfq/rfq-detail/components/quote-supplier-profile/quote-supplier-profile.component';
import { AccessDeniedComponent } from '../component/access-denied/access-denied.component';
import { ChangePasswordModule } from '../component/change-password/change-password.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    NgbModule.forRoot(),
    HttpClientModule,
    PerfectScrollbarModule,
    DialogModule,
    ClickOutsideModule,
    FormsModule,
    ChangePasswordModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    NgbModule,
    SanitizeNolImtHtmlPipe,
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    HttpClientModule,
    PerfectScrollbarModule,
    dateFormatPipe,
    TitleComponent,
    FieldErrorDisplayComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    ClickOutsideModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    ShowErrorsComponent,
    AngularGooglePlaceModule,
    GroupByPipe,
    PhonePipe,
    SanitizeHtmlPipe,
    NaPipe,
    OriginalFileName,
    OriginalFileShortName,
    DotLimit,
    CustomStatusPipe,
    MiniBuyerProfileComponent,
    NPSColorStates,
    RfqCapabilitiesComponent,
    QuoteSupplierProfileComponent,
    AccessDeniedComponent,

  ],
  declarations: [
    SanitizeNolImtHtmlPipe,
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    TitleComponent,
    CardComponent,
    dateFormatPipe,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    ShowErrorsComponent,
    FieldErrorDisplayComponent,
    MiniBuyerProfileComponent,
    GroupByPipe,
    PhonePipe,
    SanitizeHtmlPipe,
    DotLimit,
    NaPipe,
    OriginalFileName,
    OriginalFileShortName,
    DotLimit,
    CustomStatusPipe,
    NPSColorStates,
    RfqCapabilitiesComponent,
    QuoteSupplierProfileComponent,
    AccessDeniedComponent,

  ],
  providers: [{
    provide: PERFECT_SCROLLBAR_CONFIG,
    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  }]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts